<template>
    <section class="categories">
        <div class="container">
            <div class="columns is-multiline">
                <div 
                    class="column is-4-desktop is-6-tablet is-12-mobile" 
                    v-for="(item, index) in categoriesData" 
                    :key="index"            
                >
                    <router-link
                        :to="{
                            name: item.title,
                            params: { type: item.type, id: item._id, slug: getSlug(item.url)},
                        }"
                        class="categories__item"
                        :class="lowerCasedtitle(item.title)"
                        :style="{ 'background-image': 'url(' + getBg(item) + ')' }"
                    >
                        <vue-load-image>
                            <template v-slot:image >
                                <img class="categories__animation" :src="item.animation.image_url" v-if="item.animation && item.animation.image_url"/>
                            </template>
                            <template v-slot:preloader> 
                                <img class="categories__animation" :src="getImg(item.image)"/>
                            </template>
                        </vue-load-image>

                        <!-- <img :src="item.animation.image_url" v-if="item.animation && item.animation.image_url" class="categories__animation"> -->
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import VueLoadImage from 'vue-load-image'
import { parseImageUrl } from '../../mixins/useParseImage';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import { useMeta } from 'vue-meta'

export default {
    name: "Categories",
    data() {
        return {
            CATEGORY_LIST: "/api/krainaabc/category/list?device=www",
            categoriesData: []
        };
    },
    components: {
        'vue-load-image': VueLoadImage
    },
    mixins: [parseImageUrl],
    computed: {
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        history() {
            return this.$store.getters.getHistory;
        }
    },
    methods: {
        getCategories() {
            axios.get(`${this.CATEGORY_LIST}`).then((response) => {
                if (response.status === 200) {
                    if(response.data.data && response.data.data.items && response.data.data.items.length > 0) {
                        if(response.data.data && response.data.data.items) {
                            this.categoriesData = response.data.data.items.filter((item)=> {
                                return item
                            });
                        }
                    }
                }
            });
        },
        getSlug(url) {
            return url.substring(url.lastIndexOf("/") + 1) 
        },
        getBg(item) {
            if(item.animation && item.animation.background_url) {
                return item.animation.background_url + '?v=2';
            }
            return null;
        },
        lowerCasedtitle(title) {
            return title.toLowerCase().split(' ').join('_');
        },
        getImg(img) {
            if(img && img.url) {
                return parseImageUrl(img.url,250,0);
            }
        }
    },  
    mounted() {
        this.getCategories();
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );

        const store = useStore();
        let id;

        if(this.$route.params.id) {
            id = parseInt(this.$route.params.id);
        } else {
            if(this.history.some(el => el.path === this.path)) {
                id = this.history.find(el => el.path === this.path).id;
            } else {
                id = window.__pageSettings.id;
            }
        }

        store.dispatch('getMeta', { id: id });
        const metaData = computed(() => store.getters.getMetaData);
        const meta_title = ref(null);
        const meta_description = ref(null);
        const meta_keywords = ref(null);
        const meta_url = ref(null);

        watch(
            () => metaData.value,
            (newValue) => {
                if (newValue && newValue.data) {
                    meta_keywords.value = newValue.data.meta_keywords;
                    meta_title.value = newValue.data.meta_title;
                    meta_description.value = newValue.data.meta_description;
                    meta_url.value = newValue.data.url
                }
            }
        );
        
        const computedMeta = computed(() => ({
            title: meta_title.value ? meta_title.value : '',
            description: meta_description.value ? meta_description.value : '',
            link: [
                {
                    rel: 'canonical',
                    href: meta_url.value ? meta_url.value : '',
                },
            ],
            meta: [
              { property: 'keywords', content: meta_keywords.value ? meta_keywords.value : '' },
            ]
        }))

        useMeta(computedMeta);
    }  
}
</script>